import Axios from 'axios';
import Qs from 'qs';

export default {

  // 报修工单分页列表
  listPage(
    community_id,
    repair_order_no,
    repair_order_type,
    repair_items_id,
    repair_order_booking_datetime_start,
    repair_order_booking_datetime_end,
    repair_owner_keywords,
    repair_order_state,
    repair_order_pay_status,
    page,
    per_page
  ) {
    return Axios.get('/wybx/api/admin/repair_order', {
      params: {
        community_id,
        repair_order_no,
        repair_order_type,
        repair_items_id,
        repair_order_booking_datetime_start,
        repair_order_booking_datetime_end,
        repair_owner_keywords,
        repair_order_state,
        repair_order_pay_status,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 取消报修工单
  cancel(
    id,
    cancel_order_reason_id
  ) {
    return Axios.post(`/wybx/api/admin/cancel_repair_order/${id}`, {
      cancel_order_reason_id
    });
  },

  // 设为已缴报修工单
  setPay(
    id
  ) {
    return Axios.post(`/wybx/api/admin/repair_order/pay/${id}`);
  },

  // 评价报修工单
  evaluate(
    id,
    repair_order_comment_content,
    repair_order_comment_processing_speed,
    repair_order_comment_service_attitude,
    repair_order_comment_professional_degrees
  ) {
    return Axios.post(`/wybx/api/admin/repair_order/add_comment/${id}`, {
      repair_order_comment_content,
      repair_order_comment_processing_speed,
      repair_order_comment_service_attitude,
      repair_order_comment_professional_degrees
    });
  },

  // 报修订单新增
  add(
    community_id,
    repair_order_type,
    repair_items_id,
    repair_order_location,
    repair_order_location_housing_id,
    repair_order_booking_datetime,
    repair_order_content,
    repair_order_attachment_ids
  ) {
    return Axios.post('/wybx/api/admin/repair_order', {
      community_id,
      repair_order_type,
      repair_items_id,
      repair_order_location,
      repair_order_location_housing_id,
      repair_order_booking_datetime,
      repair_order_content,
      repair_order_attachment_ids
    });
  },

  // 报修订单上门时间列表
  timeList() {
    return Axios.get('/wybx/api/admin/service_datetime');
  },

  // 报修订单详情
  info(
    id
  ) {
    return Axios.get(`/wybx/api/admin/repair_order/${id}`);
  },

  // 分配订单
  assign(
    community_id,
    id,
    repair_attendant_ids
  ) {
    return Axios.post(`/wybx/api/admin/assigned_orrder_to_attendant/${id}`, {
      community_id,
      repair_attendant_ids
    });
  },

  // 是否有新报修
  isNew() {
    return Axios.get(`/wybx/api/admin/repair_order_tips`);
  },

  // 催办
  urge(
    id
  ) {
    return Axios.post(`/wybx/api/admin/urgent_repair_order/${id}`);
  },

  // 导出
  exportList(
    community_id,
    repair_order_no,
    repair_order_type,
    repair_items_id,
    repair_order_booking_datetime_start,
    repair_order_booking_datetime_end,
    repair_owner_keywords,
    repair_order_state,
    repair_order_pay_status
  ) {
    return Axios.get('/wybx/api/admin/repair_order_export', {
      params: {
        community_id,
        repair_order_no,
        repair_order_type,
        repair_items_id,
        repair_order_booking_datetime_start,
        repair_order_booking_datetime_end,
        repair_owner_keywords,
        repair_order_state,
        repair_order_pay_status
      },
      responseType: 'blob'
    });
  }

}